import React, {useState,useEffect,useCallback} from 'react'
import apiClient from '../../utils/api/apiClient'
import { APIEndpoints } from '../../utils/api/apiConfig'
import styled from 'styled-components';
import StarIcon from '../../assets/icons/star.png'
import GrayStarIcon from '../../assets/icons/star_gray.png'
import { useTranslation } from 'react-i18next'
import { makeCall } from '../../utils/api/makeCall'
import useStores from '../../stores/useStore'

const StyledImage = styled.div`
height:24px;
width:24px;
background-size: contain;
background-image: none;
background-image: url(${props => props.image ? props.image : ""});
`
const FavoriteItem = ({articleId}) => {
    const { t } = useTranslation()
    const { teamOrderStore } = useStores()
    const [/*errorStates*/, setErrorStates] = useState({})
    const [/*loadingStates*/, setLoadingStates] = useState({})
    const [articleIsFavorite, setArticleIsFavorite] = useState(false)
    const getFavoriteStatus = useCallback(async () => {
        await makeCall('getArticleFavoriteStatus', async () => {
            let resp = await apiClient.getJson(APIEndpoints.articleGetFavorite(articleId))
            setArticleIsFavorite(resp)
        }, setErrorStates, setLoadingStates)
    },[articleId])
    const setFavoriteStatus = async () => {
        await makeCall('setArticleFavoriteStatus', async () => {
            let resp = await apiClient.putJson(APIEndpoints.articleSetFavorite(articleId, articleIsFavorite))
            setArticleIsFavorite(resp)
            teamOrderStore.loadArticleCatalogs(true)
        }, setErrorStates, setLoadingStates)
    }
    useEffect(() => {
        getFavoriteStatus()
      }, [getFavoriteStatus])

    return (
        <div data-toggle="tooltip" data-placement="right" title={articleIsFavorite ? t('productsOverview:removeFromFavorites') : t('productsOverview:addToFavorites')}>
            <StyledImage style={{ cursor: "pointer" }} image={articleIsFavorite ? StarIcon : GrayStarIcon} onClick={() => { setFavoriteStatus()}} />
        </div>
    )
}

export default FavoriteItem